import { StorefrontMark } from '@/components/warehouse/storefronts'
import type { YmEconomicsShowcase } from '@/lib/api/schemas/ymarket-pricing.schema'
import { formatRubleAmount } from '@/lib/market-money'
import { unavailableReasonText } from '@/lib/warehouse/labels'
import { showcasePricesText } from '@/lib/ymarket-pricing'

function collectedText(value: string): string {
  return new Date(value).toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Moscow' })
}

/** The Russian tooltip: the buyer's price with and without Yandex Pay and the report time. */
export function showcaseDescription(showcase: YmEconomicsShowcase): string {
  if (showcase.payPrice === null) return `Цена на витрине: ${unavailableReasonText(showcase.unavailableReason ?? 'showcase_not_collected')}`
  const prices = showcasePricesText(showcase.payPrice, showcase.noPayPrice)
  const moment = showcase.collectedAt === null ? '' : ` · отчёт Маркета ${collectedText(showcase.collectedAt)}`
  return `Покупатель заплатит на витрине: ${prices}${moment}`
}

/** One number: what the buyer pays on the showcase with Yandex Pay; the rest is in the tooltip. */
export function MarketShowcasePrice({ showcase }: { showcase: YmEconomicsShowcase | null }) {
  const reason = showcase?.unavailableReason ?? 'showcase_not_collected'
  const description = showcase === null ? `Цена на витрине: ${unavailableReasonText(reason)}` : showcaseDescription(showcase)
  const price = showcase?.payPrice ?? null
  return (
    <span
      data-showcase={price === null ? 'unknown' : 'known'}
      data-reason={price === null ? reason : undefined}
      title={description}
      aria-label={description}
      className={`inline-flex items-center gap-1 whitespace-nowrap tabular-nums ${price === null ? 'text-ink-muted' : ''}`}
    >
      <StorefrontMark providerCode="ymarket" size={14} opacity={price === null ? 0.55 : 1} />
      <span>{price === null ? '—' : formatRubleAmount(price)}</span>
    </span>
  )
}
